import {React,useState} from 'react'
import './Somes.css'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
import Collapsible from 'react-collapsible';
const Iq2 = () => {
    return (
        <div className='container'>
                 <NavLink to='/category/Interview question/8'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Interview question/6'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'80px'}}>&lt;- Previous page </Button>
</NavLink>
<div class="concepts">
<a > Aptitude Concepts</a>
</div>
<div>
<h1 class="h1"style={{float:'left'}}> Aptitude Questions</h1>
<h3 style={{float:'right'}}> Topics: <b>Volume Surface And area</b></h3>
</div>

<br /> <br /> <br /> <br />

<br />

<td>
<p class="pq">1) The surface area of a cube is 600 cm2. The length of its diagonal is</p>
<ol class="pointsu">
<li className='list'><img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area-q1.png" style={{margin:'5px 4px -10px 0px'}} alt="Apti Volume and Surface Area"/> cm</li> 
<li className='list'><img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area-q1_1.png" style={{margin:'5px 4px -10px 0px'}} alt="Apti Volume and Surface Area"/> cm</li> 
<li className='list'>10 <img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area-q1_2.png" alt="Apti Volume and Surface Area"/> cm</li> 
<li className='list'>10 <img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area-q1_3.png" style={{margin:'5px 4px -10px 0px'}} alt="Apti Volume and Surface Area"/> cm</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show Answer'>  
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>Surface area of cube = 6 a<sup>2</sup> <br/>
600 = 6 a<sup>2</sup><br/>
a<sup>2</sup> = 100 <br/>
&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp;a= <img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area-q1_4.png" style={{margin:'5px 4px -10px 0px'}} alt="Apti Volume and Surface Area"/>=10 cm<br/>
Diagonal of cube = <img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area-q1_2.png" alt="Apti Volume and Surface Area"/>  a = <img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area-q1_2.png" alt="Apti Volume and Surface Area"/> × 10 = 10 <img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area-q1_2.png" alt="Apti Volume and Surface Area"/>cm</p>
</div> </Collapsible>
<br />

<p class="pq">2) The length of the longest rod that can be placed in a room 30 m long, 24 m broad and 18 m high, is</p>
<ol class="pointsu">
<li className='list'>30 m </li>
<li className='list'>15 <img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area-q1_3.png" style={{margin:'5px 4px -10px 0px'}} alt="Apti Volume and Surface Area"/> m</li>
<li className='list'>30 <img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area-q1_3.png" style={{margin:'5px 4px -10px 0px'}} alt="Apti Volume and Surface Area"/> m</li>
<li className='list'>60 m</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'>  
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>Length of room = 30 m<br/>
Breadth of room = 24 m<br/>
Height of room = 18 m <br/>
<img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area-q2.png" style={{margin:'5px 4px -10px 0px'}} alt="Apti Volume and Surface Area"/></p>
</div> </Collapsible>
<br />

<p class="pq">3) The dimensions of a hall are 40 m, 25 m and 20 m. If each person requires 200 cubic meters, find the number of persons who can be accommodated in the hall.</p>
<ol class="pointsu">
<li className='list'>150</li>
<li className='list'>140</li>
<li className='list'>120</li>
<li className='list'>100</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show Answer'>  
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p>Length of the hall = 40 m<br/>
Breadth of hall= 25 m<br/>
Height of hall = 20 m <br/>
Volume of the hall = l x b x h <br/>
&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;= 40 x 25 x 20 = 20,000 m<sup>3</sup><br/>
Space occupied by each person = 200m<sup>3</sup><br/>
Number of person that can accommodate in the hall =<img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area-q3.png" style={{margin:'5px 4px -18px 0px'}}alt="Apti Volume and Surface Area"/></p>
</div> </Collapsible>
<br />

<p class="pq">4) 4 cubes each of 6 cm<sup>2</sup> total surface area and another cube of 24 cm<sup>2</sup> total surface area are placed together in such a way to form a rectangular parallelepiped. The total surface area of the parallelepiped so formed is</p>
<ol class="pointsu">
<li className='list'>48 cm<sup>2</sup></li>
<li className='list'>40 cm<sup>2</sup></li>
<li className='list'>36 cm<sup>2</sup></li>
<li className='list'>32 cm<sup>2</sup></li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer'>  
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>Total surface area of parallelepiped = total surface area of 4 cubes + Surface area of another cube<br/>
So, the required surface area = 4 x6 + 24 = 48 cm<sup>2</sup></p>
</div> </Collapsible>
<br />

<p class="pq">5) A water tank is 30 m long, 20 m wide and 12 m deep. It is made of iron sheet which is 3 m wide. The tank is open at the top. If the cost of iron sheet is Rs. 10 per meter, what is the total cost of iron sheet required to build the tank?</p>
<ol class="pointsu">
<li className='list'>Rs. 6000</li>
<li className='list'>Rs. 8000</li>
<li className='list'>Rs. 9000</li>
<li className='list'>Rs. 10,000</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'>  
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>Length of water tank = 30 m<br/>
Width of water tank = 20 m<br/>
Depth of water tank = 12 m</p>
<p>Area of water tank = 2(lb+bh +hl) - lb</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; = 2 (30 x 20 + 20 x 12 + 12 x 30) - 30 x 20<br/>
&nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; = 2 (600 + 240 + 360) - 600 <br/>
&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; = 2 (1200) - 600 <br/>
&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; = 2400 - 600 = 1800 m<sup>2</sup> </p>
<p>Area of iron sheet (L*B) = area of tank = 1800 m<sup>2</sup></p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; L * B = 1800<br/>
&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; L x 3 = 1800<br/>
&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; L = 1800/3 = 600 m</p>
Given that, the cost of iron sheet is Rs. 10 per meter.<br/>
So, the total cost of iron sheet to build the tank = 10 x 600 = Rs. 6000<p></p>
</div> </Collapsible>
<br/>





<p class="pq">6) In a shower 10 cm of rain falls. What is the volume of water that falls on 1.5 hectares of ground?</p>
<ol class="pointsu">
<li className='list'>1500 m<sup>3</sup></li>
<li className='list'>1400 m<sup>3</sup></li>
<li className='list'>1200 m<sup>3</sup></li>
<li className='list'>1000 m<sup>3</sup></li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show Answer'>  
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>1 hectare = 10,000 m<sup>2</sup><br/>
1.5 hectare = 1.5 x 10 x 1000 = 15,000 m<sup>2</sup><br/>
Depth = 10 cm of rainfall =<img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area14.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Volume and Surface Area"/></p>
<p>∴ Volume of water = Area * Depth <br/>
15,000 *<img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area14.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Volume and Surface Area"/> = 1500 m3</p>
</div> </Collapsible>
<br />

<p class="pq">7) The dimensions of a piece of iron in the shape of a cuboid are 270 cm x 100 cm x 64 cm. If it is melted and recast into a cube, find the surface of the cube.</p>
<ol class="pointsu">
<li className='list'>14,400 cm<sup>2</sup></li>
<li className='list'>44,200 cm<sup>2</sup></li>
<li className='list'>57,600 cm<sup>2</sup></li>
<li className='list'>86,400 cm<sup>2</sup></li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'>  
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p>Volume of iron piece = l x b x h <br/>
&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;= 270 x 100 x 64 = 1,728,000 cm<sup>3</sup><br/>
Volume of cuboid = volume of cube <br/>
&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp;1,728,000 = a<sup>3</sup><br/>
&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;a <img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area16.png" style={{margin:'5px 4px -5px 0px'}} alt="Apti Volume and Surface Area"/><br/>
Surface area of cube = 6 a<sup>2</sup><br/>
= 6 x 1202= 86,400 cm<sup>2</sup></p>
</div> </Collapsible>
<br />

<p class="pq">8) Surface area of a sphere is 5544 cm2. Its volume will be</p>
<ol class="pointsu">
<li className='list'>30808 cm<sup>3</sup></li> 
<li className='list'>38808 cm<sup>3</sup></li> 
<li className='list'>380808 cm<sup>3</sup></li> 
<li className='list'>380800 cm<sup>3</sup></li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show Answer'>  
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>Surface area of sphere = 4 π r<sup>2</sup>=5544 cm<sup>2</sup><br/>
<img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area17.png" alt="Apti Volume and Surface Area"/><br/>
Volume of a sphere <img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area18.png" alt="Apti Volume and Surface Area"/></p>
</div> </Collapsible>
<br />

<p class="pq">9) If two spheres have their radii in the ratio 2: 3, the ratio of their volumes is</p>
<ol class="pointsu">
<li className='list'>8 : 27</li>
<li className='list'>4 : 9</li>
<li className='list'>6 : 12</li>
<li className='list'>1 : 15 </li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer'>  
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p> Let the radius of both the spheres be 'r' and 'R', respectively.<br/>
&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;r: R = 2: 3<br/>
Volume of sphere = <img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area19.png" style={{margin:'5px 4px -12px 0px'}} alt="Apti Volume and Surface Area"/> <br/>
Ratio between the volume of spheres =<img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area20.png" style={{margin:'5px 4px -25px 0px'}} alt="Apti Volume and Surface Area"/><br/>
&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  =8:27</p>
</div> </Collapsible>
<br />

<p class="pq">10) The radius of hemisphere is 3 cm. The ratio of its volume to the total surface area is</p>
<ol class="pointsu">
<li className='list'>1: 3</li>
<li className='list'>2: 1</li>
<li className='list'>1: 1</li>
<li className='list'>2: 3</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'>  
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p>Radius of hemisphere = 3 cm<br/>
<img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area21.png" alt="Apti Volume and Surface Area"/> <img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area21_1.png" alt="Apti Volume and Surface Area"/><br/>
Ratio = 2: 3</p>
</div> </Collapsible>
<br/>



<br/><br/>


<p class="pq">11) If the curved surface area of a sphere is same as the curved surface area of a hemisphere, find the radius of the hemisphere.</p>
<ol class="pointsu">
<li className='list'>Same as that of the sphere.</li>
<li className='list'><img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area-q1_3.png" style={{margin:'5px 4px -8px 0px'}} alt="Apti Volume and Surface Area"/> times that of the sphere.</li>
<li className='list'><img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area-q1_2.png" style={{margin:'5px 4px -5px 0px'}} alt="Apti Volume and Surface Area"/> times that of the sphere.</li>
<li className='list'>2 times that of the sphere.</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show Answer'>  
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>Curved surface area of a sphere = Curved surface area of a hemisphere<br/>
&nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp; 4 π R<sup>2</sup>= 2 π r<sup>2</sup><br/>
 &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp; &nbsp;&nbsp; 2 R<sup>2</sup>= r<sup>2</sup><br/>
Radius of hemisphere i.e. 'r' = <img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area-q11.png" style={{margin:'5px 4px -8px 0px'}} alt="Apti Volume and Surface Area"/>= <img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area-q1_3.png" style={{margin:'5px 4px -8px 0px'}} alt="Apti Volume and Surface Area"/> R</p><br/>
</div> </Collapsible>
<br />

<p class="pq">12) The radii of two cylinders are in the ratio of 2: 3 and their heights are in the ratio of 5: 3. The ratio of their volume is</p>
<ol class="pointsu">
<li className='list'>4: 9</li> 
<li className='list'>9: 4</li> 
<li className='list'>20: 27</li> 
<li className='list'>20: 25</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'>  
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>Let the radius of both cylinders be 2x and 3x. <br/>
Let the height of both cylinders be 5y and 3y.<br/>
Ratio of the volume of two cylinders <img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area22.png" style={{margin:'5px 4px -12px 0px'}} alt="Apti Volume and Surface Area"/><br/>
Ratio = 20: 27</p>
</div> </Collapsible>
<br />
<p class="pq">13) The radius of road roller is 1 meter and length 7/22 meter. When it is rolled on a ground then it rolls 500 times to level the ground. But it was found that on 5% part of the ground, roller rolled twice. What is the total area of the ground?</p>
<ol class="pointsu">
<li className='list'>1000/Π<sup>2</sup> m<sup>2</sup></li>
<li className='list'>975 <img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area-q13.png" style={{margin:'5px 4px -5px 0px'}} alt="Apti Volume and Surface Area"/> m<sup>2</sup></li>
<li className='list'>975 m<sup>2</sup></li>
<li className='list'>950 m<sup>2</sup></li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show Answer'>  
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p>Let the area of the ground = x meter<br/>
The area covered in 1 revolution by the roller = 2Πrl<br/>
<img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area23.png" alt="Apti Volume and Surface Area"/></p>
</div> </Collapsible>
<br />

<p class="pq">14) A copper sphere of radius 3 cm is beaten and drawn into a wire of diameter 0.2 cm. The length of the wire is</p>
<ol class="pointsu">
<li className='list'>9 m</li>
<li className='list'>12 m</li>
<li className='list'>18 m</li>
<li className='list'>36 m</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer'>  
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p>Radius of wire =<img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area25.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Volume and Surface Area"/> = 0.1 </p>
<p>Volume of sphere = Volume of cylinder<br/>
<img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area26.png" alt="Apti Volume and Surface Area"/></p>
</div> </Collapsible>
<br />

<p class="pq">15) A hollow sphere of internal and external diameters 4 cm and 8 cm respectively is melted to form a solid cylinder of base diameter 8 cm. What is the height of the cylinder?</p>
<ol class="pointsu">
<li className='list'>4.5 cm</li> 
<li className='list'>4.57 cm</li>
<li className='list'>4.67 cm</li>
<li className='list'>4.7 cm</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'>  
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>Let the height of the cylinder be h.<br/>
According to question: <br/>
Volume of cylinder = Volume of hollow sphere<br/>
<img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area28.png" alt="Apti Volume and Surface Area"/></p>
</div> </Collapsible>
<br/>




<p class="pq">16) The length, breadth, and height of a brick are 10 cm, 4 cm, and 3 cm, respectively. Find the surface area of the brick?</p>
<ol class="pointsu">
<li className='list'>154 cm<sup>2</sup></li> 
<li className='list'>156 cm<sup>2</sup></li> 
<li className='list'>160 cm<sup>2</sup></li> 
<li className='list'>164 cm<sup>2</sup></li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show Answer'>  
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p>Surface area of a Cuboid = 2(lb+ bh+ hl) cm<sup>2</sup><br/>
So, <br/>
Surface area of a brick = 2(10*4+4*3+3*10) cm<sup>2</sup><br/>
= 2(82) cm<sup>2</sup>= 164 cm<sup>2</sup></p>
</div>  </Collapsible>
<br />

<p class="pq">17) A 6 m long and 4 m wide cistern contains water up to a breadth of 1 m 25 cm. Find the total surface area of the surface immersed in water?</p>
<ol class="pointsu">
<li className='list'>42 m<sup>2</sup></li>
<li className='list'>49 m<sup>2</sup></li>
<li className='list'>52 m<sup>2</sup></li>
<li className='list'>64 m<sup>2</sup></li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'>  
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>Area of the wet surface = <br/>
2[lb+ bh+ hl] - lb = 2 [bh+ lh] + lb<br/>
= 2[(4*1.25+6*1.25)] +6*4 = 49 m<sup>2</sup></p>
<p><strong>Solution 2</strong>:<br/>
The area of the wet surface= Area of the base + area of the two walls 2 * (4 *1.25) + area of the other two walls 2 * (6 * 1.25) cm <br/>
= 6*4 + 2 (4*1.25) + 2 (6*1.25)  <br/>
= 24+ 10 + 15 = 49 m<sup>2</sup></p>
</div> </Collapsible>
<br />

<p class="pq">18) A boat of length 3 m and breadth 2 m is floating on a lake. The boat sinks by 1 cm when a man gets into it. What is the mass of the man?</p>
<ol class="pointsu">
<li className='list'>50 Kg</li> 
<li className='list'>60 Kg</li> 
<li className='list'>70 Kg</li> 
<li className='list'>80 Kg</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show Answer'>  
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>In this type of question, first, we will calculate the volume of water displaces then we will multiply it with the density of water.<br/>
1 cm = 0.06 m <br/>
Volume of water displaced = 3*2*0.01 = 0.06 m cube<br/>
Mass of Man = Volume of water displaced * Density of water (around 1000 kg/m<sup>3</sup>)<br/>
&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;= 0.06 * 1000 = 60 kg</p>
</div> </Collapsible>
<br />

<p class="pq">19) A swimming pool 9 m wide and 12 m long is 1 m deep on the shallow side and 4 m deep on deeper side. Find the volume of the swimming pool?</p>
<ol class="pointsu">
<li className='list'>260</li>
<li className='list'>262</li>
<li className='list'>270</li>
<li className='list'>272</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer'>  
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>Volume will be length * breadth * height, <br/>
But, in this case two heights are given so we will take average,</p>
<p><img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area30.png" alt="Apti Volume and Surface Area"/><br/>
12*9*2.5m<sup>3</sup>=270m<sup>3</sup></p>
</div> </Collapsible>
<br />

<p class="pq">20) The cost of the paint is Rs. 36.50 per kg. If 1 kg of paint covers 16 square feet, how much will it cost to paint outside of a cube having 8 feet each side</p>
<ol class="pointsu">
<li className='list'>850</li> 
<li className='list'>860</li> 
<li className='list'>876</li> 
<li className='list'>886</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'>  
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>We will first calculate the Surface area of the cube, and then we will calculate the quantity of paint required.<br/>
Surface area = 6a<sup>2</sup> <br/>
=6*8<sup>2</sup>=384 sq feet<br/>
16 square feet is covered by 1 kg of paint.<br/>
384 square feet will be covered by = <img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area-q20.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Volume and Surface Area"/>= 24kg of paint</p>
<p>As per the question, the cost of the paint is Rs. 36.50 per kg. <br/>
So, the total cost of painting =36.50*24<br/>
=Rs.876</p>
</div> </Collapsible>
<br/>




<br/><br/>



<p class="pq">21) How many bricks, each measuring 25cm*11.25cm*6cm, will be needed to build a wall 8m*6m*22.5m?</p>
<ol class="pointsu">
<li className='list'>610000</li> 
<li className='list'>620000</li> 
<li className='list'>630000</li> 
<li className='list'>640000</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show Answer'>  
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p>To solve this type of question, simply divide the volume of the wall with the volume of brick to get the required number of bricks.<br/>
Number of bricks: <br/>
=<img src="https://static.javatpoint.com/aptitude/images/volume-and-surface-area31.png" style={{margin:'5px 4px -15px 0px'}} alt="Apti Volume and Surface Area"/>= 640000 </p>
</div> </Collapsible>
<br/>




<br/><br/>

</td>
        </div>
    )
}

export default Iq2
